import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
              韩漫阅读
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              作为韩漫爱好者，您可以在韩漫网站免费观看下拉式韩国漫画大全，在线浏览各种热门作品，轻松又愉快。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              分类导航
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              热门推荐
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/article/3"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  我独自升级
                </Link>
              </li>
              <li>
                <Link
                  to="/article/2"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  全知读者视角
                </Link>
              </li>
              <li>
                <Link
                  to="/article/1"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  女神降临
                </Link>
              </li>
              <li>
                <Link
                  to="/article/6"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  梨泰院Class
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  用户口碑
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 韩漫阅读 - 韩漫免费漫画在线观看平台。本站所有内容均来自网络，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm text-background-200"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-sm text-background-200"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}